<h1 mat-dialog-title> Desafiliar</h1> <br />

<form #desafiliacionForm=ngForm>
    <mat-dialog-content>

        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3"> <label> Fecha de desafiliación: </label> </div>

            <div class="col-lg-5">
                <input id="fechaDesafiliacion" name="fechaDesafiliacion" [(ngModel)]="data.fechaDesafiliacion"
                    placeholder="Fecha desafiliación" class="form-control" type="date" />

            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />

        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3"> <label> Motivo desafiliación: </label> </div>

            <div class="col-lg-5">

                <textarea name="motivo" id="motivo" [(ngModel)]="data.motivo" class="form-control" cols="30"
                    rows="10"></textarea>

            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />

    </mat-dialog-content> <br />
</form>
<mat-dialog-actions>
    <button mat-button class="mat-raised-button btn-success" (click)="onDesafiliarAfiliado(desafiliacionForm)">
        Desafiliar
    </button>

    <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
        <i class="fa fa-trash"> </i> Salir
    </button>

</mat-dialog-actions>

<br />